var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "zoom-text" }, [_vm._v("ZOOM")]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "zoom-level-text",
        on: {
          click: function ($event) {
            return _vm.$emit("click")
          },
        },
      },
      [_vm._v(_vm._s(Math.floor(_vm.zoomLevel)))]
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: "zoom-input-field" + (_vm.expanded ? " active" : "") },
      [
        _c(
          "vue-slider",
          _vm._b(
            {
              staticClass: "no-drag",
              scopedSlots: _vm._u([
                {
                  key: "dot",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "custom-drag-dot" }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "custom-drag-dot-circle custom-drag-dot-circle-top-left",
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "custom-drag-dot-circle custom-drag-dot-circle-top-center",
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "custom-drag-dot-circle custom-drag-dot-circle-top-right",
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "custom-drag-dot-circle custom-drag-dot-circle-bottom-left",
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "custom-drag-dot-circle custom-drag-dot-circle-bottom-center",
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "custom-drag-dot-circle custom-drag-dot-circle-bottom-right",
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.newZoomLevel,
                callback: function ($$v) {
                  _vm.newZoomLevel = $$v
                },
                expression: "newZoomLevel",
              },
            },
            "vue-slider",
            _vm.sliderOptions,
            false
          )
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }